// extracted by mini-css-extract-plugin
module.exports = {"energy-container":"energy-label-product-info-component_energy-container__3M88l","energy-link":"energy-label-product-info-component_energy-link__1UFje"};